'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp; // import {
//   usersConnection,
// } from '../../query';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = require('react-apollo');

var _View = require('./View');

var _View2 = _interopRequireDefault(_View);

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UsersPage = (_temp = _class = function (_Page) {
  _inherits(UsersPage, _Page);

  function UsersPage(props) {
    _classCallCheck(this, UsersPage);

    return _possibleConstructorReturn(this, (UsersPage.__proto__ || Object.getPrototypeOf(UsersPage)).call(this, props)); // this.state = {}
  }

  _createClass(UsersPage, [{
    key: 'setPageMeta',
    value: function setPageMeta(meta) {
      return _get(UsersPage.prototype.__proto__ || Object.getPrototypeOf(UsersPage.prototype), 'setPageMeta', this).call(this, meta || {
        title: this.lexicon("Users")
      });
    }
  }, {
    key: 'addObject',
    value: function addObject(event) {
      var history = this.props.history;
      history.push('/users/create/');
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var View = this.props.View; // return;

      var Renderer = this.state.Renderer;

      if (!Renderer) {
        var _ref = this.context.query || {},
            usersConnection = _ref.usersConnection;

        if (usersConnection) {
          var _Renderer = (0, _reactApollo.compose)((0, _reactApollo.graphql)((0, _graphqlTag2.default)(usersConnection), {// name: 'items', 
          }))(View);

          Object.assign(this.state, {
            Renderer: _Renderer
          });
        }
      }

      _get(UsersPage.prototype.__proto__ || Object.getPrototypeOf(UsersPage.prototype), 'componentWillMount', this) && _get(UsersPage.prototype.__proto__ || Object.getPrototypeOf(UsersPage.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          View = _props.View,
          limit = _props.first,
          data = _props.data,
          other = _objectWithoutProperties(_props, ['View', 'first', 'data']);

      var Renderer = this.state.Renderer;

      if (!Renderer) {
        return null;
      }

      var uri = this.context.uri;

      var _uri$query = uri.query(true),
          page = _uri$query.page;

      page = parseInt(page) || 0;
      var skip = page ? (page - 1) * limit : 0;
      return _get(UsersPage.prototype.__proto__ || Object.getPrototypeOf(UsersPage.prototype), 'render', this).call(this, _react2.default.createElement(Renderer // addObject={event => {
      //   this.addObject(event);
      // }}
      , _extends({
        page: page,
        skip: skip,
        first: limit,
        limit: limit,
        data: data,
        title: this.lexicon("Users")
      }, other)));
    }
  }]);

  return UsersPage;
}(_layout2.default), _class.propTypes = _extends({}, _layout2.default.propTypes, {
  View: _propTypes2.default.func.isRequired
}), _class.defaultProps = _extends({}, _layout2.default.defaultProps, {
  View: _View2.default,
  first: 10,
  orderBy: "username_ASC"
}), _temp);
exports.default = UsersPage;
module.exports = exports['default'];